var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attributes-table"},[_c('b-tabs',{ref:"tabs"},[_c('b-tab',{attrs:{"title":"Tabela atrybutów","active":""}},[_c('features-table',{ref:"featureTable",on:{"edited-data":_vm.handleEditedData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }